import { render, staticRenderFns } from "./ViewMail.vue?vue&type=template&id=166b0852&"
import script from "./ViewMail.vue?vue&type=script&lang=js&"
export * from "./ViewMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports